import React, {useEffect, useMemo, useState} from 'react';
import {Card} from "../../generic/cards";
import {useApi} from "../../../lib/api/useApi";
import {routes} from "../../../lib/routes";
import {generateLinks} from "../Dashboard";
import {useDefaultEndpoints} from "../../../lib/api/useDefaultEndpoints";
import {Loader} from "../../generic/loader";
import {BsGear} from "react-icons/bs";
import {t} from "i18next";
import {useBases} from "../../../lib/api/basesProvider";

BasesCard.propTypes = {

};

function BasesCard() {
    const {userRole} = useApi();
    const [baseRoutes, setBasesRoutes] = useState([]);
    const bases = useMemo(() => routes.find(r => t(r.title) === t('routes.bases')), [])
    const {bases: _bases} = useBases();

    useEffect(() => {
        if (_bases.length > 0) {
            const loadedBases = _bases.filter(b => !b.is_kids).map(base => ({
                title: base.name,
                to: '/bases/' + base.url + '/events',
                access: ['Super-admin', 'Administrator', 'Sport', 'Call-center'],
                extraLinks: [
                    {
                        link: <div className={'btn btn-light btn-rounded p-0 ml-2'} title={'Редактирование'}>
                            <BsGear/></div>,
                        to: '/bases/' + base.url,
                    }
                ],
                accessKey: `SIDEBAR-BASES-ENTITY-ID-${base.id}`
            }))
            setBasesRoutes(() => loadedBases);
        }
    }, [_bases])

    return !_bases.length
        ? <Loader/>
        :(<Card title={t('routes.bases')} className={'col-xs-3 col-md-6 col-lg-6 col-xl-3 grid-margin stretch-card'}>
            {generateLinks({...bases, children: baseRoutes}, userRole)}
        </Card>);
}

export default BasesCard;